'use strict';

function isHTTPS() {
  return global.location.protocol === 'https:';
}

module.exports = {
  isHTTPS: isHTTPS
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/braintree-web-drop-in/lib/is-https.js
// module id = 179
// module chunks = 0